<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Район</label>
              <Select2
                class="select2"
                :options="districtList"
                v-model="currFilters.districtId"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Организация, предоставившая услуги</label>
              <Select2
                class="select2"
                placeholder="Не выбрано"
                :options="organizationList"
                v-model="currFilters.imarOrgId"
              />
            </div>
          </div>

          <div class="col-12" style="display:none">
            <div class="form-group">
              <label>Период</label>
              <div class="patient-date__range" style="display: flex">
                <date-component
                  @keyupEnter="apply"
                  v-model="currFilters.periodFrom"
                />
                <div class="mx-2 my-1">-</div>
                <date-component
                  @keyupEnter="apply"
                  v-model="currFilters.periodTo"
                />
              </div>
            </div>
          </div>

          <div class="filter-block-header filter-block-header-no-background">Диагностика</div>
          <div class="col-12">
            <div class="form-group">
              <Select2
                @keyup.enter="apply"
                placeholder="Все"
                class="select2"
                :options="diagnosticsOptions"
                v-model="currFilters.hasDiagnostics"
              />
            </div>
          </div>

          <div class="filter-block-header">ИМАР</div>
          <div class="col-12">
            <div class="form-group">
              <label>Период оказания услуг</label>
              <div class="patient-date__range" style="display: flex">
                <date-component
                  @keyupEnter="apply"
                  v-model="currFilters.imarPeriodFrom"
                />
                <div class="mx-2 my-1">-</div>
                <date-component
                  @keyupEnter="apply"
                  v-model="currFilters.imarPeriodTo"
                  :class-name="{ 'input-error': v$.currFilters.imarPeriodTo.$invalid }"
                />
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>Статус</label>
              <Select2
                @keyup.enter="apply"
                placeholder="Все"
                class="select2"
                :options="imarOptions"
                :settings="{ multiple: true, placeholder: '-- не выбрано --' }"
                v-model="currFilters.imarStatusIds"
              />
              <div v-if="currFilters.imarStatusIds && currFilters.imarStatusIds.some(x => x == 8)" style="font-size:small; color: #7F7F82;">
                Отсутствие получения: Отсутствуют отметки о фактах получения услуг 30 и более дней, относительно текущей даты.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>Предоставляемые услуги</label>
              <Select2
                @keyup.enter="apply"
                placeholder="Все"
                class="select2"
                :options="serviceTypes"
                :settings="{ multiple: true, placeholder: '-- не выбрано --' }"
                v-model="currFilters.imarServiceIds"
              />
            </div>
          </div>
          
          <div class="filter-block-header">ИППСУ</div><!-- filter-block-header-no-background -->
          <div class="col-12">
            <div class="form-group">
              <label>Статус</label>
              <Select2
                @keyup.enter="apply"
                placeholder="Все"
                class="select2"
                :options="ippsuOptions"
                :settings="{ multiple: true, placeholder: '-- не выбрано --' }"
                v-model="currFilters.ippsuStatusIds"
              />
            </div>
          </div>

          <div class="filter-block-header">ПМПК</div>
          <div class="col-12">
            <div class="form-group">
              <label>Статус</label>
              <Select2
                @keyup.enter="apply"
                placeholder="Все"
                class="select2"
                :options="pmpkOptions"
                v-model="currFilters.hasPmpk"
              />
            </div>
          </div>

          <div class="filter-block-header">ИПРА</div>
          <div class="col-12">
            <div class="form-group">
              <label>Статус</label>
              <Select2
                @keyup.enter="apply"
                placeholder="Все"
                class="select2"
                :options="ipraOptions"
                v-model="currFilters.ipraStatusId"
              />
            </div>
          </div>

          <div class="filter-block-header d-flex justify-content-between" @click="personalDataCollapsed = !personalDataCollapsed">
            Персональные данные
            <div class="ml-3" :class="{active: !personalDataCollapsed}">
                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.46875 8.9375C6.75 9.21875 7.21875 9.21875 7.5 8.9375L13.5938 2.875C13.875 2.5625 13.875 2.09375 13.5938 1.8125L12.875 1.09375C12.5938 0.8125 12.125 0.8125 11.8125 1.09375L7 5.90625L2.15625 1.09375C1.84375 0.8125 1.375 0.8125 1.09375 1.09375L0.375 1.8125C0.09375 2.09375 0.09375 2.5625 0.375 2.875L6.46875 8.9375Z" fill="#7F7F82"/>
                </svg>
            </div>
          </div>
          <div v-if="!personalDataCollapsed">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <component-input
                    @keyupEnter="apply"
                    placeholder="Введите ФИО"
                    v-model="currFilters.FIO"
                    label="ФИО"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <component-input
                    @keyupEnter="apply"
                    placeholder="XXX-XXX-XXX YY"
                    type="snils"
                    v-model="currFilters.snils"
                    mod-class="snils"
                    label="СНИЛС"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label>Дата рождения</label>
                  <div class="patient-date__range" style="display: flex">
                    <date-component
                      @keyupEnter="apply"
                      v-model="currFilters.dateOfBirthFrom"
                    />
                    <div class="mx-2 my-1">-</div>
                    <date-component
                      @keyupEnter="apply"
                      v-model="currFilters.dateOfBirthTo"
                      :class-name="{ 'input-error': v$.currFilters.dateOfBirthTo.$invalid }"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <component-input
                    @keyupEnter="apply"
                    label="Возраст"
                    placeholder="Введите возраст"
                    v-model="currFilters.age"
                    type="int"
                  />
                </div>
              </div>
            <!--          <div class="col-12">-->
            <!--            <div class="form-group">-->
            <!--              <label>Пол</label>-->
            <!--              <Select2 @keyup.enter="apply" placeholder="Все" class="select2" :options="maleOptions"  v-model="currFilters.male"/>-->
            <!--            </div>-->
            <!--          </div>-->
            <!-- <div class="col-12">
              <div class="form-group">
                <label>Дневник согласован</label>
                <select class="form-control" v-model="currFilters.isConfirmed">
                      <option v-bind:value='null'>Все</option>
                      <option v-bind:value='true'>Да</option>
                      <option v-bind:value='false'>Нет</option>
                </select>
              </div>
            </div> -->

            <!--          <div class="col-12">-->
            <!--            <div class="form-group">-->
            <!--              <label>ИМАР</label>-->
            <!--              <select class="form-control" v-model="currFilters.hasImar">-->
            <!--                    <option v-bind:value='null'>Все</option>-->
            <!--                    <option v-bind:value='true'>Да</option>-->
            <!--                    <option v-bind:value='false'>Нет</option>-->
            <!--              </select>-->
            <!--            </div>-->
            <!--          </div>-->
          <!-- </div> -->
            
              <div class="col-12">
                <div class="form-group">
                  <label>Тип документа</label>
                  <Select2
                    @keyup.enter="apply"
                    class="select2"
                    :options="docTypeList"
                    v-model="currFilters.docType"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <component-input
                    @keyupEnter="apply"
                    v-model="currFilters.docSerieNum"
                    label="Серия/номер документа"
                    placeholder="Серия/номер документа"
                  />
                </div>
              </div>
            </div>
          </div>

          <template v-if="canViewDeletedPermanently">
            <div class="filter-block-header mt-2">Архив</div>
            <div class="col-12">
              <div class="form-group">
                <label>Архивные записи</label>
                <select class="form-control" v-model="currFilters.isDeletedPermanently">
                  <option v-for="item in yesNoList" :value="item.id">
                    {{ item.text }}
                  </option>
                </select>
              </div>
            </div>
          </template>

        </div>
      </div>
      <div class="card-footer d-flex">
        <button-component class="col-6" @click="apply">
          Применить
        </button-component>
        <button-component class="col-6" kind="secondary" @click="reset">
          Сбросить
        </button-component>
      </div>
    </div>
  </div>
</template>

<script>
import { ru } from "date-fns/locale";
import ButtonComponent from "@/common/ui/ButtonComponent";
import ComponentInput from "@/common/components/ComponentInput";
import Constants from "../../../common/constants";
import Utils from "@/common/utils";
import DateComponent from "@/common/components/DateComponent";
import NsiApi from "../../admin/api/nsi";
import OrgApi from "../../admin/api/organizations";
import { useVuelidate } from "@vuelidate/core";
import security from "../../../common/mixins/security";

export default {
  name: "JournalsFilters",
  components: { ComponentInput, ButtonComponent, DateComponent },
  mixins: [security],
  props: {
    filters: Object,
  },
  data() {
    return {
      locale: ru,
      imarOptions: [
        {id: 1, text: "действует первично"},
        {id: 2, text: "действует повторно"},
        {id: 4, text: "завершен"},
        {id: 8, text: "не реализован", title: "Отсутствие получения: Отсутствуют отметки о фактах получения услуг 30 и более дней, относительно текущей даты."},
        {id: 16, text: "нет"},
      ],
      serviceTypes: [],
      ippsuOptions: [
        { id: 1, text: "актуальная" },
        { id: 2, text: "изменена" },
        { id: 4, text: "завершена" },
        { id: 8, text: "отменена" },
        { id: 16, text: "нет" },
      ],
      pmpkOptions: [
        { id: 1, text: "Все", selected: true, value: null },
        { id: true, text: "Да", value: true },
        { id: false, text: "Нет", value: false },
      ],
      ipraOptions: [
        { id: 1, text: "действует" },
        { id: 2, text: "завершена" },
        { id: 3, text: "нет" },
      ],
      maleOptions: [
        { id: 1, text: "Все", selected: true },
        { id: true, text: "Мужской", value: true },
        { id: false, text: "Женский", value: false },
      ],
      organizationList: [
        {
          id: 0,
          text: Constants.emptySelectOptionText,
          selected: false,
        },
      ],
      docTypeList: [
        { id: 3, text: Constants.emptySelectOptionText, selected: true },
        {
          text: "Паспорт РФ",
          id: 0,
        },
        {
          text: "Свидетельство о рождении",
          id: 1,
        },
      ],
      districtList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      diagnosticsOptions: [
        {
          id: 1,
          text: "Все",
        },
        {
          id: true,
          text: "Да",
        },
        {
          id: false,
          text: "Нет",
        },
      ],
      yesNoList: Constants.yesNoList,
      currFilters: this.filters,
      canViewDeletedPermanently: false,
      personalDataCollapsed: true
    };
  },
  methods: {
    apply() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        if(this.v$.currFilters.dateOfBirthTo.$invalid) {
          this.personalDataCollapsed = false;//развернуть блок с персональными данными
        }
        Constants.alert.fire(
          "Ошибка",
          "Проверьте правильность заполнения фильтров",
          "error"
        );
        return;
      }

      const filters = Object.assign({}, this.currFilters);
      this.$emit("apply", filters);
    },
    reset() {
      this.currFilters = {
        FIO: "",
        docSerieNum: "",
        docType: 0,
        snils: "",
        isConfirmed: null,
        districtId: 0,
        imarOrgId: 0,
        age: null,
        hasImar: null,
        male: null,
        hasPmpk: null,
        isDeletedPermanently: false
      };
      const filters = Object.assign({}, this.currFilters);
      this.$emit("reset", filters);
    },
  },
  created() {
    this.checkPermission(Constants.PatientDeletePermanentlyView).then((response) => {
      this.canViewDeletedPermanently = response.data;
      if(!this.canViewDeletedPermanently)
        this.isDeletedPermanently = false;
    });
    Utils.loadSelectOptions("district", this.districtList, {
      regionId: Constants.regionNizhnyNovgorodId,
    });
    NsiApi.getServiceTypes(null).then((response) => {
      this.serviceTypes = response.data;
    });
    OrgApi.search().then((response) => {
      this.organizationList = response.data.items.map((item) => ({id: item.id, text: item.name}));
      this.organizationList.unshift({id: 0, text: Constants.emptySelectOptionText, selected: true});
    });
  },
  mounted() {},
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      currFilters: {
        imarPeriodTo: { notBeforeFrom: (value) => {
          if (!value) return true;
          if (!this.currFilters.imarPeriodFrom) return true;
          return new Date(value) >= new Date(this.currFilters.imarPeriodFrom);
        } },
        dateOfBirthTo: { notBeforeFrom: (value) => {
          if (!value) return true;
          if (!this.currFilters.dateOfBirthFrom) return true;
          return new Date(value) >= new Date(this.currFilters.dateOfBirthFrom);
        } },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/theme/default/colors";
.form-group {
  label {
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
  }
}

.card-footer {
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
.select2::v-deep {
  .select2-container {
    width: 100%;
  }
  .select2-container--default .select2-selection--single {
    height: calc(2.25rem + 2px) !important;
  }

  .select2-container--default
    .select2-selection--single
    .select2-selection__arrow {
    top: 7px !important;
  }
}
.filter-block-header {
  padding: 8px;
  background-color: $gray-light2;

  &-no-background {
    background-color: transparent;
  }
}

.active{
    transform: rotate(180deg);
}
</style>
